export enum resetPasswordRouteParameterEnum {
  admin = 'admin',
  user = 'user',
}
